import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CookiesPolitics from "./CookiesPolitics";

export default function CookiesNotification(props) {
  useEffect(() => {
    if (
      new Date().getTime() >
      Number(localStorage.getItem("coockies-accepted")) + 7 * 24 * 3600 * 1000
    )
      localStorage.removeItem("coockies-accepted");
  }, []);

  const handleCookies = () => {
    localStorage.setItem("coockies-accepted", new Date().getTime());
  };

  return (
    <>
      {!localStorage.getItem("coockies-accepted") && (
        <div
          id="CookieNotification"
          className="alert alert-warning d-flex flex-column stick-top mb-0 alert-dismissible fixed-bottom ps-4 pe-4"
          role="alert"
        >
          <div className="text-align-justify fw-light">
            Nós usamos cookies para melhorar sua experiência de navegação no
            portal. Ao utilizar o cbtkd.org.br, você concorda com a política de
            monitoramento de cookies. Para ter mais informações sobre como isso
            é feito, acesse{" "}
            <a
              className="text-decoration-none"
              data-bs-toggle="offcanvas"
              href="#offcanvasCookiesPolitics"
              role="button"
              aria-controls="offcanvasCookiesPolitics"
            >
              Política de cookies
            </a>
            . Se você concorda, clique em ACEITO.
          </div>
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-warning ms-3"
              onClick={handleCookies}
              data-bs-dismiss="alert"
              aria-label="Close"
            >
              Aceito
            </button>
          </div>
        </div>
      )}
      <CookiesPolitics />
    </>
  );
}
